angular.module('mtic.components.modules.c4', [
]).constant('C4_ASSET_URL', 'assets/images/c4-meta/')
